import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp, CommonAppProps, Context, Entity } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { Commands } from "../core/util/commandManager";
import { Sheet, SheetEventType } from "../../siteManagement/sheet";
import { General } from "../../siteManagement/general";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Config } from "../core/config/config";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Dialog, DialogProps } from "../core/components/dialog";
import { ComponentHelper } from "../core/util/componentHelper";
import { FieldInstance } from "../core/components/field";
import { DropDownList } from "../core/components/dropDownList";
import { DragAndDrop } from "../core/components/dnd";
import { EmailRecipient, EmailRecipientKind } from "./template/template";
import { MetaDataHelper } from "../core/util/metaDataHelper";
import { DocumentWrapper, FileWrapper } from "./attachments";
import { KeyValuePair, StringKeyDictionary } from "../commonInterfaces";
import React from "react";
import ReactDOM from "react-dom";

export class EmailApp extends React.Component<EmailAppProps, { isInitializing: boolean }> {
    private selectedFiles: Array<File> = [];
    private fileRefernces: Array<FileWrapper> = [];
    private selectedDocs: Array<DocumentWrapper> = [];
    private factory = ComponentHelper.createFactory();
    private sheet: Sheet;
    noBookmark = true;
    common = new AppHelper();
    setTabTitle = true;
    translations: StringKeyDictionary<string>;
    filesEnabled = true;
    docsEnabled = false;
    sendEnabled = true;
    selectTemplateEnabled = true;
    searchUrls: {};
    historyEnabled: boolean = false;
    types: any;
    forwardEmailActive: boolean;
    private jobId: number;

    constructor(props: EmailAppProps) {
        super(props);
        this.jobId = props.context.keyVal1;
        this.forwardEmailActive = Helper.hasValue(this.jobId) && !this.props.context.forward;
        this.common.enableHooks = true;
        this.historyEnabled = !Helper.isNullOrEmpty(this.props.context.itemKey) && !Helper.isNullOrEmpty(this.props.context.contextType);
        this.filesEnabled = this.props.context.filesEnabled;
        this.docsEnabled = this.props.context.documentsEnabled;
        if (Helper.hasValue(this.props.entity.Documents)) {
            this.selectedDocs = this.props.entity.Documents.map((id) => {
                return {
                    docObject: null,
                    documentName: null,
                    fileName: null,
                    id: id,
                    labelRef: null
                }
            });
        }
        this.sheet = General.Sheet.Manager.getTopMostSheet();
        this.common.init(this);

        this.common.commandManager.registerExecutor("emailAttachmentMounted", (command, data) => {
            let exitingFiles = this.props.entity.FileNames;
            if (Helper.hasValue(this.fileRefernces) && Helper.hasValue(exitingFiles)) {
                this.fileRefernces.forEach((fr) => {
                    exitingFiles.push(fr.fileName)
                });

                exitingFiles = exitingFiles.filter((value, index, array) => {
                    return array.indexOf(value) === index;
                })
            }
            


            this.common.commandManager.runCommand("emailAttachment", Commands.DYNAMIC, {
                existingFiles: exitingFiles,
                existingDocuments: this.selectedDocs,

            });
            this.common.commandManager.runCommand("htmlEditor", Commands.REFRESH);

        });

        this.state = { isInitializing: Helper.hasValue(this.props.context.defaultTemplate) || Helper.hasValue(this.props.respondeToMailId) }

        this.initApp();
    }

    private initApp = async () => {

        await this.preloadData();

        if (Array.isArray(this.props.receiver)) {
            this.handleFieldChange({ model: "entity.RecipientEmails" }, this.mapMails(EmailRecipientKind.Regular, this.props.entity.RecipientEmails, []));
        }

        if (this.props.entity.RecordRight.CanWrite == true) {
            if (!Helper.isNullOrEmpty(this.props.subject)) {
                this.handleFieldChange({ model: "entity.EmailSubject" }, this.props.subject, true);
            }

            if (!Helper.isNullOrEmpty(this.props.senderName)) {
                this.handleFieldChange({ model: "entity.SenderName" }, this.props.senderName, true);
            }

            if (!Helper.isNullOrEmpty(this.props.senderEmail)) {
                this.handleFieldChange({ model: "entity.SenderEmail" }, this.props.senderEmail, true);
            }
        }
        this.setState({ isInitializing: false });

    }
    private preloadData = async () => {
        if (this.props.context.forward) {
            return;
        }
        const tryLoadDefaultTemplate = async () => {
            if (Helper.hasValue(this.props.context.defaultTemplate) ) {
                await this.loadTemplateData(this.props.context.defaultTemplate, this.getType(), this.props.templateLanguageCode);
            }
        }

        if (Helper.hasValue(this.props.respondeToMailId)) {
            await this.loadRespondeToMailData(this.props.respondeToMailId, this.props.answerToAll);
            await tryLoadDefaultTemplate();
        } else {
            await tryLoadDefaultTemplate()
        }
    }

    private prepareEmail = (): FormData => {
        const formData = new FormData();
        formData.append("SenderName", this.props.entity.SenderName);
        formData.append("SenderEmail", this.props.entity.SenderEmail);
        formData.append("Recipient", this.props.entity.Recipient);
        formData.append("RecipientEmails", this.props.entity.RecipientEmails);
        formData.append("CCNames", this.props.entity.CCNames);
        formData.append("CCEmails", this.props.entity.CCEmails);
        formData.append("BCCNames", this.props.entity.BCCNames);
        formData.append("BCCEmails", this.props.entity.BCCEmails);
        formData.append("EmailSubject", this.props.entity.EmailSubject);
        formData.append("EmailBody", this.props.entity.EmailBody);
        formData.append("Context", this.props.context.appContext);
        formData.append("ContextKey", this.props.context.itemKey);


        if (Array.isArray(this.selectedFiles)) {
            for (let i = 0; i < this.selectedFiles.length; i++) {
                if (Helper.hasValue(this.selectedFiles[i])) {
                    formData.append("files", this.selectedFiles[i]);
                }
            }
        }

        if (Array.isArray(this.selectedDocs)) {
            for (let i = 0; i < this.selectedDocs.length; i++) {
                if (Helper.hasValue(this.selectedDocs[i])) {
                    formData.append("Documents", this.selectedDocs[i].id.toString());
                }
            }
        }

        if (Array.isArray(this.fileRefernces)) {

            for (let i = 0; i < this.fileRefernces.length; i++) {
                if (Helper.hasValue(this.fileRefernces[i])) {
                    formData.append("FileRefernces", this.fileRefernces[i].filePath);
                }
            }
        }

        return formData;
    }

    private handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {

        switch (field.model) {
            case "entity.RecipientEmails":
                if (Helper.hasValue(dataItem)) {
                    let names = this.mapMailsToNameListString(dataItem);
                    this.handleFieldChange({ model: "entity.Recipient" }, names, dataItem);
                }
                break;
            case "entity.CCEmails":
                if (Helper.hasValue(dataItem)) {
                    let names = this.mapMailsToNameListString(dataItem);
                    this.handleFieldChange({ model: "entity.CCNames" }, names, dataItem);
                }
                break;
            case "entity.BCCEmails":
                if (Helper.hasValue(dataItem)) {
                    let names = this.mapMailsToNameListString(dataItem);
                    this.handleFieldChange({ model: "entity.BCCNames" }, names, dataItem);
                }
                break;
            case "files":
                this.selectedFiles = value.filter(f => Helper.hasValue(f));
                const data = this.selectedFiles.map((file) => { return file.name })
                this.handleFieldChange({ model: "entity.FileNames" }, data)
                isInit = true;
                break;
            case "docs":
                this.selectedDocs = dataItem;
                isInit = true;
                break;
            case "attachedFiles":
                this.fileRefernces = value;
                isInit = true;
                break;
            default:
                break;
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    private mapMailsToNameListString = (data: any[]) => {
        return data.map((item) => { return item.Name }).join("#_#");
    }

    private validate = async () => {
        if (this.common.validate()) {
            let result = true;
            const noSubject = Helper.isNullOrEmpty(this.props.entity.EmailSubject);
            const noContent = Helper.isNullOrEmpty(this.props.entity.EmailBody);
            if (noSubject && noContent) {
                result = await this.request(this.translations["WebCRM.Email.Validation.NoContentAndSubject"]);
            } else if (noContent) {
                result = await this.request(this.translations["WebCRM.Email.Validation.NoContent"]);
            } else if (noSubject) {
                result = await this.request(this.translations["WebCRM.Email.Validation.NoSubject"]);
            }
            return result;
        } else {
            return false;
        }
    }

    private request = (inner: string) => {
        return new Promise<boolean>((resolve) => {
            const dialogProps: DialogProps = {

                title: Helper.getTranslation("WebCRM.Email.Validation.SendAnyway"),
                actions: [
                    {
                        label: this.translations["WebCRM.Email.NotSend"],
                        action: () => {
                            resolve(false);
                        },
                        primary: false
                    },
                    {
                        label: this.translations["WebCRM.Email.Send"],
                        action: () => {
                            resolve(true);
                        },
                        primary: true
                    }
                ],

            };
            const targetElement = $("<div>");
            $("body").append(targetElement);
            ReactDOM.render(
                <Dialog {...dialogProps} open={true}>
                    <div dangerouslySetInnerHTML={{ __html: inner }} ></div>
                </Dialog >, targetElement[0]);


        })
    }

    forwardMail = () => {
        const url = Config.baseUrl + `EmailSender/Forward?id=${this.jobId}`;
        Helper.openInNewBrowserTab(url);
    }

    sendEmail = async () => {
        const isValid = await this.validate();
        if (isValid) {
            const formData = this.prepareEmail();
            const result = await HTTPService.post<JsonResultClass<number>>('EmailSender/SendEmail', formData);
            if (result.Code === 0) {
                NotificationHelper.showSuccessMessage(result.Message);
                this.props.entity.IsNew = false;
                this.props.entity.RecordRight.CanWrite = false;
                this.common.setEntityDirtyState(false);
                General.Functions.HistoryState.replaceState(`EmailSender/Show?id=${result.Data}`);
                this.jobId = result.Data;
                this.forwardEmailActive = true;
                this.historyEnabled = false;
                this.setState({});
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            this.common.handlePostSave(result.Code === 0, false);
        }
    }

    openSelectTemplate = () => {
        let type = this.getType();
        const sheet = General.Sheet.Manager.createSheetWithUrl(`DynamicSearch/Window/emailTemplate?type=${type}&disabled=type`);
        sheet.setTitle(this.translations["WebCRM.Email.SelectTemplate"]);
        sheet.bind(SheetEventType.RowClicked, async (templateId) => {
            try {
                const languageCode = await this.selectLanguage(templateId);
                this.loadTemplateData(templateId, type, languageCode);
            } catch (e) {
                NotificationHelper.showErrorMessage(e)
            }

        });
    }

    openHistory = () => {
        window.open(`${Config.baseUrl}EmailSender/History?type=${this.getType()}&itemKey=${this.props.context.itemKey}`, '_blank');
    }

    private compareTypes = (type: number) => {
        let currentType = -1
        switch (this.getType()) {
            case "ticket":
                currentType = 7;
                break;
            case "servicereport":
                currentType = 1;
                break;
            case "weeklyreport":
                currentType = 2;
                break;
            case "customreport":
                currentType = 3;
                break;
            case "resourceplanning":
                currentType = 4;
                break;
            case "machine":
                currentType = 5;
                break;
            case "resource":
                currentType = 6;
                break;
            case "travelExpenseReport":
                currentType = 13;
                break;
            case "general":
                currentType = 14;
                break;
        }


        //    Address = 8,
        //    Material = 9,
        //    Project = 10,
        //    ContactPerson = 11,
        //    User = 12


        return currentType == type;
    }

    private selectLanguage = (templateId: number) => {
        return new Promise<string>(async (resolve, reject) => {
            const results = await Promise.all([
                HTTPService.get<JsonResultClass<[]>>("EditIndividualFields/GetLanguages"),
                HTTPService.get<JsonResultClass>("EmailSender/InitTemplate?id=" + templateId)
            ]);

            const template = results[1].Data.Data;
            if (!this.compareTypes(results[1].Data.Type)) {
                reject("Bitte wählen Sie einen gültigen Entitätstyp")
                return;
            }

            const keys = Object.keys(template);

            if (keys.length == 1) {
                resolve(keys[0]);
            } else if (keys.length > 1) {
                const userLanguage = (results[0].Data as any[]).find(f => f.Id == Config.user.languageId);
                const dataSource: KeyValuePair<string, string>[] = Object.keys(results[1].Data.Data).map((key) => {
                    let lang = (results[0].Data as any[]).find(f => f.Code == key);
                    return { Key: key, Value: `${lang.Displaynameen} (${lang.Displaynamenative})` }
                });
                let value = Helper.hasValue(userLanguage) ? userLanguage.Code : dataSource[0].Key;
                const targetElement = $("<div>");
                const dialogProps: DialogProps = {
                    title: "",
                    width: 500,
                    actions: [
                        {
                            label: Config.translations.cancel,
                            action: () => {
                            },
                        },
                        {
                            label: Config.translations.ok,
                            action: () => {
                                resolve(value);
                            },
                            primary: true
                        },
                    ],
                    afterClose: () => {
                        ReactDOM.unmountComponentAtNode(targetElement[0]);
                        targetElement[0].remove();
                    }
                };

                let props = this.factory.getDefaultDropDownProps();
                props.dataSource = dataSource;
                props.value = value;
                props.field.dataTextField = "Value";
                props.field.dataValueField = "Key";
                props.field.optionLabel = "";
                props.onChange = (_, code) => {
                    value = code;
                }
                $("body").append(targetElement);
                ReactDOM.render(
                    <Dialog {...dialogProps} open={true}>
                        <FieldInstance label={this.translations["Field.Adresse.language"]}>
                            <DropDownList {...props} />
                        </FieldInstance>
                    </Dialog >, targetElement[0]);
            } else {
                NotificationHelper.showErrorMessage("Unexpected Error occured");
            }
        })
    }

    private loadTemplateData = async (templateId: number, type: string, languageCode: string) => {
        if (Helper.isNullOrEmpty(languageCode) && this.props.openLanguageSelection) {
            languageCode = await this.selectLanguage(templateId);
        }
        let url = "EmailSender/GetEmailTemplate";
        let email = await HTTPService.post<JsonResultClass<{}>>(url, {
            TemplateId: templateId,
            LanguageCode: languageCode,
            ItemKey: this.props.context.itemKey,
            Context: type,
            InnerBody: this.props.entity.EmailBody
        });
        if (email.Code == 0) {
            this.handleTemplate(email.Data);
        } else {
            NotificationHelper.showErrorMessage(email.Message);
        }
        this.setState({ isInitializing: false });
    }
    private mapMails = (kind: EmailRecipientKind, mails: string, mailAddresses: EmailRecipient[]) => {
        let result = mailAddresses
            .filter(f => f.Kind === kind)
            .map(x => x.EmailAddress)
            .concat(Helper.isNullOrEmpty(mails) ? [] : mails.split(","));
        switch (kind) {
            case EmailRecipientKind.Regular:
                if (Helper.hasValue(this.props.receiver) && this.props.receiver.length > 0) {
                    result = Helper.mergeLists(result, this.props.receiver);
                }
                break;
            case EmailRecipientKind.CarbonCopy:
                if (Helper.hasValue(this.props.cc) && this.props.cc.length > 0) {
                    result = Helper.mergeLists(result, this.props.cc);
                }
                break;
            case EmailRecipientKind.BlindCarbonCopy:
                if (Helper.hasValue(this.props.bcc) && this.props.bcc.length > 0) {
                    result = Helper.mergeLists(result, this.props.bcc);
                }
                break;
        }


        result = result.filter(f => !Helper.isNullOrEmpty(f));
        return result.join(",");
    }

    private handleTemplate = (data: {}) => {

        if (this.props.entity.RecordRight.CanWrite) {

            const sender: string = data["Sender"];
            if (!Helper.isNullOrEmpty(sender)) {
                this.handleFieldChange({ model: "entity.SenderEmail" }, sender);
            }

            this.handleFieldChange({ model: "entity.EmailSubject" }, data["Subject"]);
            this.handleFieldChange({ model: "entity.EmailBody" }, data["Body"]);
            const mailAddresses: EmailRecipient[] = data["Recipients"];

            this.handleFieldChange({ model: "entity.RecipientEmails" }, this.mapMails(EmailRecipientKind.Regular, this.props.entity.RecipientEmails, mailAddresses));
            this.handleFieldChange({ model: "entity.CCEmails" }, this.mapMails(EmailRecipientKind.CarbonCopy, this.props.entity.CCEmails, mailAddresses));
            this.handleFieldChange({ model: "entity.BCCEmails" }, this.mapMails(EmailRecipientKind.BlindCarbonCopy, this.props.entity.BCCEmails, mailAddresses));
            this.handleFieldChange({ model: "entity.Attachments" }, data["AttachmentDocumentIds"]);
        }

        this.setState({}, () => {
            this.common.sheetWrapper.trigger(SheetEventType.Custom, { command: "triggerUpdateEmail" });
            this.common.sheetWrapper.trigger(SheetEventType.Custom, { command: "addTemplateFiles", docs: data["AttachmentDocumentIds"] });
        })
    }

    private loadRespondeToMailData = async (respondeToMailId: string, answerToAll: boolean) => {
        const url = `Document/GetMsgOrEmlPreview?documentguid=${respondeToMailId}`;
        const email = await HTTPService.get<any>(url);
        console.log(email)
        let recipients = null;
        let cc = null;
        if (answerToAll) {
            cc = Helper.hasValue(email.cc) ? (Array.isArray(email.cc) ? email.cc.join(',') : email.cc) : "";
            recipients = `${email.from},${email.recipients.map(rec => rec.Email).join(',')}`
        } else {
            recipients = email.from;
        }

        this.handleFieldChange({ model: "entity.EmailSubject" }, email.subject);
        this.handleFieldChange({ model: "entity.EmailBody" }, email.html);
        this.handleFieldChange({ model: "entity.RecipientEmails" }, recipients);
        this.handleFieldChange({ model: "entity.Recipient" }, recipients);
        this.handleFieldChange({ model: "CCEmails" }, cc);
        this.setState({ isInitializing: false });
    }

    private getType = () => {
        switch (this.props.context.appContext.toLowerCase()) {
            case "contact":
            case "contactperson":
                return "contact";
            case "resourceplanning":
            case "assignment":
                return "resourceplanning";
            case "parts":
                return "material";
            case "user":
            case "usersettings":
                return "usersettings";
            case "crreport":
                return "customreport";
            case "edittravelreport":
                return "travelExpenseReport";
            default:
                return this.props.context.appContext.toLowerCase();
        }
    }

    private handleDrop = (files) => {
        this.sheet.trigger(SheetEventType.Custom, { command: "addFiles", files: files })
    }

    render() {
        if (this.state.isInitializing) {
            return null;
        }
        let props: CommonAppProps = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        props.showContextReminders = false;
        return (
            <>
                {this.props.entity.RecordRight.CanWrite && this.props.context.filesEnabled ? (<DragAndDrop handleDrop={this.handleDrop} style={{ height: "100%", width: "100%" }}><CommonApp {...props} /></DragAndDrop>) : (<><CommonApp {...props} /></>)}
            </>
        );
    }
}

export interface EmailAppProps extends AppBaseProps {
    entity: EmailEntity;
    context: EmailPropsContext;
    subject: string;
    senderName: string;
    senderEmail: string;
    receiver: Array<string>;
    cc: Array<string>;
    bcc: Array<string>;
    respondeToMailId: string;
    answerToAll: boolean;
    templateLanguageCode: string;
    openLanguageSelection: boolean;
}

export interface EmailPropsContext extends Context {
    //elementId?: string;
    filesEnabled: boolean;
    documentsEnabled: boolean;
    appContext: string;
    contextUrl?: string;
    itemKey?: string;
    defaultTemplate?: number;
    jobId?: number;
    forward?: boolean;
    notAllowedDocumentFileTypes?: string[]
}

//email
export interface EmailEntity extends Entity {
    SenderName: string;
    SenderEmail: string;
    Recipient: string;
    RecipientEmails: string;
    CCNames: string;
    CCEmails: string;
    BCCNames: string;
    BCCEmails: string;
    EmailSubject: string;
    EmailBody: string;
    Context: string;
    ContextKey: string;
    Documents: Array<number>;
    FileNames: Array<string>;
}